module.exports = __webpack_public_path__ + "img/case-logo-25.a8370b1d.png";